import { Integration } from '@dadohr/shared/domainTypes/integrations';
import {
  IntegrationDataMap,
  MergeHRISIntegration
} from '@dadohr/shared/domainTypes/integrations/merge';
import { UserImportSourceType } from '@dadohr/shared/domainTypes/user';
import { MERGE_HRIS_INTEGRATIONS } from '../../../../../Org/pages/Integrations';
import {
  getMergeIntegrationLogo,
  getMergeSmallIntegrationLogo
} from '../../../../../Org/pages/Integrations/integrations/merge';

export type ImportSourceIntegrationInfo = {
  comingSoon: boolean;
  logoUrl: string;
  name: string;
  smallLogoUrl: string;
  type: UserImportSourceType;
  integration: Integration;
  mergeHRIS?: MergeHRISIntegration;
};

type ImportIntegrations =
  | Integration.BAMBOOHR
  | Integration.BOB
  | Integration.AIRTABLE
  | Integration.WORKDAY
  | Integration.GOOGLE_SHEETS
  | Integration.SFTP
  | Integration.GREENHOUSE_V3
  | Integration.PERSONIO
  | Integration.MICROSOFT
  | Integration.CHARTHOP
  | Integration.PINGBOARD
  | Integration.ADP_WORKFORCE_NOW
  | Integration.ASHBY
  | Integration.EMAIL_CSV
  | Integration.SALESFORCE;

export const IMPORT_META = {
  AIRTABLE: {
    type: UserImportSourceType.AIRTABLE,
    integration: Integration.AIRTABLE,
    name: 'Airtable',
    logoUrl: '/images/integrations-logos/airtable.svg',
    smallLogoUrl: '/images/integrations-logos/airtable-icon.png',
    comingSoon: false
  },
  ASHBY: {
    type: UserImportSourceType.ASHBY,
    integration: Integration.ASHBY,
    name: 'Ashby',
    logoUrl: '/images/integrations-logos/ashby.png',
    smallLogoUrl: '/images/integrations-logos/ashby-icon.png',
    comingSoon: false
  },
  BAMBOOHR: {
    type: UserImportSourceType.BAMBOO_HR,
    integration: Integration.BAMBOOHR,
    name: 'BambooHR',
    logoUrl: '/images/integrations-logos/bamboohr.svg',
    smallLogoUrl: '/images/resources/bamboohr-logo.png',
    comingSoon: false
  },
  BOB: {
    type: UserImportSourceType.BOB,
    integration: Integration.BOB,
    name: 'bob',
    logoUrl: '/images/integrations-logos/bob.png',
    smallLogoUrl: '/images/integrations-logos/bob-icon.png',
    comingSoon: false
  },
  CHARTHOP: {
    type: UserImportSourceType.CHARTHOP,
    integration: Integration.CHARTHOP,
    name: 'ChartHop',
    logoUrl: '/images/integrations-logos/ic_charthop.png',
    smallLogoUrl: '/images/integrations-logos/ic_charthop.png',
    comingSoon: false
  },
  PINGBOARD: {
    type: UserImportSourceType.PINGBOARD,
    integration: Integration.PINGBOARD,
    name: 'Pingboard',
    logoUrl: '/images/integrations-logos/pingboard.svg',
    smallLogoUrl: '/images/integrations-logos/ic_pingboard.svg',
    comingSoon: false
  },
  CSV: {
    type: UserImportSourceType.MANUAL_CSV,
    name: 'CSV'
  },
  GOOGLE: {
    type: UserImportSourceType.GOOGLE_SHEET,
    integration: Integration.GOOGLE_SHEETS,
    name: 'Google Sheets',
    logoUrl: '/images/integrations-logos/google-workspace-logo.png',
    smallLogoUrl: '/images/resources/gsheet.svg',
    comingSoon: false
  },
  GREENHOUSE_V3: {
    type: UserImportSourceType.GREENHOUSE_V3,
    integration: Integration.GREENHOUSE_V3,
    name: 'Greenhouse',
    logoUrl: '/images/integrations-logos/greenhouse.svg',
    smallLogoUrl: '/images/integrations-logos/ic_greenhouse.png',
    comingSoon: false
  },
  EXCEL: {
    type: UserImportSourceType.MS_EXCEL,
    integration: Integration.MICROSOFT,
    name: 'Microsoft Excel',
    logoUrl: '/images/integrations-logos/excel.svg',
    smallLogoUrl: '/images/integrations-logos/excel.svg',
    comingSoon: false
  },
  SFTP: {
    type: UserImportSourceType.SFTP,
    integration: Integration.SFTP,
    name: 'SFTP',
    logoUrl: '/images/integrations-logos/sftp.svg',
    smallLogoUrl: '/images/integrations-logos/sftp.svg',
    comingSoon: false
  },
  WORKDAY: {
    type: UserImportSourceType.WORKDAY_REPORT_API,
    integration: Integration.WORKDAY,
    name: 'Workday',
    logoUrl: '/images/integrations-logos/workday.svg',
    smallLogoUrl: '/images/integrations-logos/workday-icon.png',
    comingSoon: false
  },
  ADP_WORKFORCE_NOW: {
    type: UserImportSourceType.ADP_WORKFORCE_NOW,
    integration: Integration.ADP_WORKFORCE_NOW,
    name: 'ADP Workforce Now',
    logoUrl: '/images/integrations-logos/adp.svg',
    smallLogoUrl: '/images/integrations-logos/adp.svg',
    comingSoon: false
  },
  PERSONIO: {
    type: UserImportSourceType.PERSONIO,
    integration: Integration.PERSONIO,
    name: 'Personio',
    logoUrl: '/images/integrations-logos/personio.svg',
    smallLogoUrl: '/images/integrations-logos/ic_personio.png',
    comingSoon: false
  },
  EMAIL_CSV: {
    type: UserImportSourceType.EMAIL_CSV,
    integration: Integration.EMAIL_CSV,
    name: 'Email CSV',
    logoUrl: '/images/integrations-logos/email-csv.svg',
    smallLogoUrl: '/images/integrations-logos/email-csv.svg',
    comingSoon: false
  },
  SALESFORCE: {
    type: UserImportSourceType.SALESFORCE,
    integration: Integration.SALESFORCE,
    name: 'Salesforce',
    logoUrl: '/images/integrations-logos/salesforce.svg',
    smallLogoUrl: '/images/integrations-logos/salesforce.svg',
    comingSoon: false
  }
};

type MergeHRISInfosMap = {
  [key in MergeHRISIntegration]?: ImportSourceIntegrationInfo;
};

const CompleteMap = {
  ...IntegrationDataMap
};

export const MergeHRISIntegrationsInfoMap = MERGE_HRIS_INTEGRATIONS.reduce(
  (map: MergeHRISInfosMap, i) => {
    if (i.mergeHrisIntegration) {
      map[i.mergeHrisIntegration] = {
        comingSoon: false,
        mergeHRIS: i.mergeHrisIntegration,
        logoUrl: getMergeIntegrationLogo(i.mergeHrisIntegration),
        smallLogoUrl: getMergeSmallIntegrationLogo(i.mergeHrisIntegration),
        name: CompleteMap[i.mergeHrisIntegration].name,
        type: UserImportSourceType.MERGE_HRIS,
        integration: i.type
      };
    }

    return map;
  },
  {}
);

export const IntegrationsInfosMap: {
  [k in ImportIntegrations]: ImportSourceIntegrationInfo;
} = {
  [Integration.AIRTABLE]: IMPORT_META.AIRTABLE,
  [Integration.ASHBY]: IMPORT_META.ASHBY,
  [Integration.BAMBOOHR]: IMPORT_META.BAMBOOHR,
  [Integration.BOB]: IMPORT_META.BOB,
  [Integration.GOOGLE_SHEETS]: IMPORT_META.GOOGLE,
  [Integration.SFTP]: IMPORT_META.SFTP,
  [Integration.GREENHOUSE_V3]: IMPORT_META.GREENHOUSE_V3,
  [Integration.PERSONIO]: IMPORT_META.PERSONIO,
  [Integration.WORKDAY]: IMPORT_META.WORKDAY,
  [Integration.MICROSOFT]: IMPORT_META.EXCEL,
  [Integration.CHARTHOP]: IMPORT_META.CHARTHOP,
  [Integration.PINGBOARD]: IMPORT_META.PINGBOARD,
  [Integration.ADP_WORKFORCE_NOW]: IMPORT_META.ADP_WORKFORCE_NOW,
  [Integration.EMAIL_CSV]: IMPORT_META.EMAIL_CSV,
  [Integration.SALESFORCE]: IMPORT_META.SALESFORCE
};
